// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yCYqG{width:264px;height:232px;padding:24px 24px 0 24px;display:flex;flex-direction:column;justify-content:space-between}.RgBdj{padding:0 24px;min-height:64px}.Qjc6H{padding:0 24px;text-align:center}.ryDaY{height:68px;padding-bottom:12px}.Sy0SP{display:grid;grid-template-columns:repeat(auto-fill, 288px);gap:16px}.l_s8o{margin-bottom:8px}.qzalm{display:flex;flex-direction:column;gap:24px}.ZjI7H{display:flex;gap:16px;flex-wrap:wrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `yCYqG`,
	"icon": `RgBdj`,
	"text": `Qjc6H`,
	"bottom": `ryDaY`,
	"cardsContainer": `Sy0SP`,
	"title": `l_s8o`,
	"section": `qzalm`,
	"cards": `ZjI7H`
};
export default ___CSS_LOADER_EXPORT___;
